import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HOME_SECTION_NAVIGATION_DELAY } from './homeSectionNavigation';

const MAX_HASH_SCROLL_FRAMES = 120;

export default function ScrollToTop() {
  const { hash, key, pathname, state } = useLocation();

  useEffect(() => {
    let animationFrameId;
    let scrollTimerId;
    let remainingFrames = MAX_HASH_SCROLL_FRAMES;

    if (hash) {
      const id = decodeURIComponent(hash.slice(1));

      const scrollToHash = () => {
        const element = document.getElementById(id);

        if (element) {
          const isMobileAccordion =
            window.matchMedia('(max-width: 767px)').matches &&
            element.querySelector('.home-section-accordion__toggle');
          const scrollToElement = () =>
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });

          if (isMobileAccordion) {
            scrollTimerId = window.setTimeout(
              scrollToElement,
              HOME_SECTION_NAVIGATION_DELAY
            );
          } else {
            scrollToElement();
          }

          return;
        }

        remainingFrames -= 1;
        if (remainingFrames > 0) {
          animationFrameId = window.requestAnimationFrame(scrollToHash);
        }
      };

      animationFrameId = window.requestAnimationFrame(scrollToHash);
      return () => {
        window.cancelAnimationFrame(animationFrameId);
        window.clearTimeout(scrollTimerId);
      };
    }

    animationFrameId = window.requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        behavior: state?.smoothScrollTop ? 'smooth' : 'auto',
      });
    });

    return () => window.cancelAnimationFrame(animationFrameId);
  }, [hash, key, pathname, state]);

  return null;
}
